import PropTypes from 'prop-types';
import React from 'react';
import ArrowPagination from '../../Elements/ArrowPagination/ArrowPagination';
import CardHeader from '../../Groups/CardHeader/CardHeader';
import GroupHomeLink from '../../Groups/Elements/GroupHomeLink/GroupHomeLink';
import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';
import UserIconList from '../UserIconList/UserIconList';

import './UserIconListDisplay.scss';

export default class UserIconListDisplay extends React.PureComponent {
    constructor(props) {
        super();
        this.initialPage = 1;
        this.state = {
            userResults: {
                results: [],
                page: 1,
                startNum: 0,
                endNum: 0,
                total: 0,
            },
        };
    }

    static propTypes = {
        /**
         * css class that could override default classes
         */
        className: PropTypes.string,
        /**
         * whether the component is going to be displayed on right rail
         */
        displayOnCenterRail: PropTypes.bool,
        /**
         * context function that fetch for userResults data
         */
        getUserList: PropTypes.func.isRequired,
        /**
         * number of users going to be displayed per page
         */
        resultsPerPage: PropTypes.number,
        /**
         * text displaying as card header
         */
        header: PropTypes.string,
        /**
         * text displaying at the bottom left corner
         */
        hint: PropTypes.string,
        /**
         * should VIP badge be shown if applicable
         */
        showVipBadge: PropTypes.bool,
    };

    static defaultProps = {
        className: '',
        displayOnCenterRail: false,
        getUserList: () => {},
        resultsPerPage: 24,
        header: '',
        hint: '',
        showVipBadge: true,
    };

    componentDidMount() {
        this.fetchUserList(this.initialPage, this.props.resultsPerPage);
    }

    fetchUserList = async (
        page = this.initialPage,
        resultsPerPage = this.props.resultsPerPage
    ) => {
        const { getUserList } = this.props;
        try {
            const res = await getUserList(page, resultsPerPage, false);
            if (res) {
                const { results, startNum, endNum, total } = res;
                this.setState({
                    userResults: {
                        results,
                        startNum,
                        endNum,
                        total,
                        page,
                    },
                });
            } else {
                throw new Error('res is not valid');
            }
        } catch (e) {
            console.log(e);
        }
    };

    getGoToPrevPage = () => {
        const { userResults } = this.state;
        const { resultsPerPage } = this.props;
        let goToPrevPage = null;
        if (userResults.page > 1) {
            goToPrevPage = () =>
                this.fetchUserList(userResults.page - 1, resultsPerPage);
        }
        return goToPrevPage;
    };

    getGoToNextPage = () => {
        const { userResults } = this.state;
        const { resultsPerPage } = this.props;
        let goToNextPage = null;
        if (userResults.page * resultsPerPage < userResults.total) {
            goToNextPage = () =>
                this.fetchUserList(userResults.page + 1, resultsPerPage);
        }
        return goToNextPage;
    };

    render() {
        const {
            userResults: { results, startNum, endNum, total },
        } = this.state;
        const {
            displayOnCenterRail,
            header,
            hint,
            className,
            showVipBadge,
        } = this.props;
        const numberRange =
            startNum && endNum ? `${startNum} - ${endNum}` : '0 - 0';
        const centerRailStyle = displayOnCenterRail ? 'center-rail' : '';

        if (!results || results.length < 1) {
            return null;
        }

        return (
            <div
                className={`component-Users-UserIconListDisplay ${centerRailStyle} ${className}`}
            >
                <CommonCardShell>
                    <CardHeader>{header}</CardHeader>
                    <UserIconList
                        userList={results}
                        userPerRow={4}
                        className="user-list"
                        showVipBadge={showVipBadge}
                    />
                    <div className="footer-section">
                        <span className="hint">{hint}</span>
                        <ArrowPagination
                            numberRange={numberRange}
                            total={total}
                            prevPage={this.getGoToPrevPage()}
                            nextPage={this.getGoToNextPage()}
                            hideArrowIfNoPagination={true}
                        />
                    </div>
                    {displayOnCenterRail && <GroupHomeLink />}
                </CommonCardShell>
            </div>
        );
    }
}
